import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
} from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { ThemesOverviewComponent } from '../../themes-overview/themes-overview.component';
import { SelectedTeamService } from '@tokenbox/services';
import { SidebarBrandLogoComponent } from '../shared/sidebar-brand-logo/sidebar-brand-logo.component';
import { PrimeIcons } from 'primeng/api';
import { SidebarFooterComponent } from '../shared/sidebar-footer/sidebar-footer.component';
import { showComingSoonDialog } from '@tokenbox/components';
import { DialogService } from 'primeng/dynamicdialog';

@Component({
  selector: 'dt-workspace-sidebar',
  templateUrl: './workspace-sidebar.component.html',
  styleUrls: ['./workspace-sidebar.component.scss'],
  imports: [
    RouterLink,
    RouterLinkActive,
    ThemesOverviewComponent,
    SidebarBrandLogoComponent,
    SidebarFooterComponent,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WorkspaceSidebarComponent {
  protected readonly PrimeIcons = PrimeIcons;

  private selectedTeamService = inject(SelectedTeamService);
  private dialogService = inject(DialogService);

  showTeamLink = computed(() => {
    const selectedTeam = this.selectedTeamService.selectedTeam();
    if (!selectedTeam?.ownPermissions) {
      return false;
    }
    return (
      selectedTeam.ownPermissions.MANAGE_TEAM &&
      selectedTeam.ownPermissions.MANAGE_WORKSPACES
    );
  });

  exportOptions: Array<{
    title: string;
    path?: string;
    url?: string;
    onClick?: () => void;
  }> = [
    {
      title: 'Figma',
      url: 'https://www.figma.com/community/plugin/1489729036216632169/design-tokens-io-figma-plugin',
    },
    {
      title: 'JSON',
      path: 'json',
    },
    {
      title: 'CSS',
      path: 'css',
    },
    {
      title: 'SCSS',
      path: 'scss',
    },
  ];

  importOptions: Array<{
    title: string;
    path?: string;
    url?: string;
    onClick?: () => void;
  }> = [
    {
      title: 'JSON',
      path: 'json',
    },
    {
      title: 'Figma',
      onClick: async () => {
        await showComingSoonDialog(this.dialogService)(
          'FIGMA_VARIABLE_IMPORT',
          `Importing Figma variables is one of our most requested features.

      Get notified as soon as it's ready!`,
        );
      },
    },
  ];
}
